import {
    renderAverageMarketPrice, renderAverageVehiclePriceGauge,
    renderAvgPriceOdoChart,
    renderDeprecationChart,
    renderOdometerHistoryChart,
    renderPriceHistogramChart,
    renderPriceOdoChart,
    renderVehicleValuationChart
} from "../utils/charts";
import * as details from "../consts/details";
import * as decodeEnums from "../enums/decode";

/**
 * Renders charts if data is available
 */
function renderCharts(chart, decode) {
    const basicVehicleInfo = decode.global.details[details.GROUP_BASIC_VEHICLE_IDENTIFICATION];
    if (!basicVehicleInfo) return;

    const make = basicVehicleInfo[details.DETAIL_MAKE]?.value;
    const model = basicVehicleInfo[details.DETAIL_MODEL]?.value;
    const year = basicVehicleInfo[details.DETAIL_MODEL_YEAR]?.value;

    if (!make || !model || !year) return;

    renderAverageVehiclePriceGauge({
        data: chart,
        make,
        model,
        year
    });

    // Average price and odometer chart
    if (chart[decodeEnums.AVG_PRICE_AND_ODO_CHART]?.details?.length) {
        renderAvgPriceOdoChart({ 
            data: chart[decodeEnums.AVG_PRICE_AND_ODO_CHART].details, 
            make, 
            model, 
            year 
        });

        const filteredData = chart[decodeEnums.AVG_PRICE_AND_ODO_CHART].details
            .filter(item => item.date_manufactured === year.toString());

        if (filteredData.length > 0) {
            const avgEuroForYear = parseFloat(filteredData[0].avg_euro_price);
            renderVehicleValuationChart(
                avgEuroForYear * 0.775, 
                avgEuroForYear * 1.225, 
                avgEuroForYear
            );
        }
    }

    // Deprecation chart
    if (chart[decodeEnums.DEPRECATION_CHART]?.details?.data?.length) {
        renderDeprecationChart(chart[decodeEnums.DEPRECATION_CHART].details);
    }

    // Price vs odometer chart
    if (chart[decodeEnums.PRICE_VS_ODO_CHART]?.details?.length) {
        renderPriceOdoChart({ 
            data: chart[decodeEnums.PRICE_VS_ODO_CHART].details, 
            make, 
            model, 
            year 
        });
        renderPriceHistogramChart({ 
            data: chart[decodeEnums.PRICE_VS_ODO_CHART].details, 
            make, 
            model, 
            year 
        });
    }

    // Odometer History
    const odometerSection = decode.global.details[details.GROUP_VEHICLE_HISTORY];
    if (odometerSection) {
        const odometerDetail = odometerSection[details.DETAIL_ODOMETER_KM];
        if (odometerDetail?.value?.length > 0) {
            renderOdometerHistoryChart(odometerDetail.value);
        }
    }
}

/**
 * Initializes the lookup component by rendering charts and populating lookup cards.
 */
export function initLookupComponent(data) {
    const {decode, chart} = data;

    if (!decode || !chart) {
        console.error('Invalid data structure');
        return;
    }

    document.getElementById("vehicle-market-value")?.classList.remove("d-none");

    renderCharts(chart, decode);
    initLookupToggle();
}

/**
 * Toggles the active state of a lookup part
 */
function toggleLookupPart(element) {
    const lookupPart = element.closest('.lookup-part');
    if (!lookupPart) return;
    
    const isOpen = lookupPart.classList.toggle('active');

    // Toggle visibility of details
    lookupPart.querySelectorAll('.lookup-details').forEach(card => {
        card.classList.toggle('hidden');
    });

    // Smooth scroll to the element
    const topOffset = 100;
    const offsetTop = lookupPart.getBoundingClientRect().top + window.pageYOffset - topOffset;
    window.scrollTo({top: offsetTop, behavior: 'smooth'});

    // Update arrow icon
    const arrowElement = lookupPart.querySelector('.lookup-arrow');
    if (arrowElement) {
        arrowElement.classList.toggle('arrow-bottom-icon', !isOpen);
        arrowElement.classList.toggle('arrow-top-icon', isOpen);
    }
}

/**
 * Initializes toggle functionality for lookup sections
 */
export function initLookupToggle() {
    document.querySelectorAll(".lookup-header, .lookup-tag-container").forEach(element => {
        element.addEventListener('click', () => toggleLookupPart(element));
    });
}
